module.exports = __webpack_public_path__ + "img/btn-border-dark-blue.5f8ce07.svg";